module.exports = __webpack_public_path__ + "img/w13-cover.8d2d2fe0.jpg";